import { create } from "domain";

export class Permissions {
  public static ServiceDesk = {
    serviceCatalog: {
      view: 3001,
      favourite: 3002,
      startService: 3003,
      rate: 3004,
    },
    manageService: {
      view: 3005,
      publish: 3006,
      create: 3007,
    },
    serviceDashboard: {
      view: 3024,
    },
    myRequests: {
      view: 3008,
      details: 3009,
      attension: 3010,
    },
    manageForms: {
      view: 3011,
      activate: 3012,
      create: 3013,
    },
    agentQueue: {
      view: 3014,
      details: 3015,
    },
    EService: {
      view: 3019,
      create: 3023,
      edit: 3020,
      delete: 3022,
      move: 3021,
    },
  };

  public static Performance = {
    Scorecard: {
      All: 6004,
      GetById: 6005,
      MyActions: 6006,
      Status: 6007,
      Create: 6008,
      Submit: 6009,
      Update: 6010,
      viewStatusDetails: 6036,
    },
    Goal: {
      Add: 6001,
      Edit: 6002,
      Delete: 6003,
    },
    Dashboard: {
      View: 6021,
    },
    Scorecard_Submission: {
      View: 6022,
    },
    Scorecard_Settings: {
      View: 6023,
    },
    Scorecard_Reports: {
      View: 6024,
    },
  };

  public static UserManagement = {
    Users: {
      view: 1000,
      delete: 1003,
    },
    Roles: {
      view: 1001,
    },
    Groups: {
      view: 1002,
    },
    Committees: {
      view: 1048,
    },
    hr: {
      permission: 8013,
    },
  };

  public static Events = {
    ListEvent: 30000,
    CreateEvent: 30001,
    UpdateEvent: 30002,
    ShareEvent: 30003,
    ViewEventDetails: 30004,
    ManageRequests: 30005,
    ViewDashboard: 30006,
  };

  public static Jobs = {
    CreateJob: 40001,
    UpdateJob: 40002,
    ListJobs: 40003,
    ViewJobDetails: 40004,
    ListJobApplications: 40007,
    ViewJobApplication: 40008,
    ViewDashboard: 40009,
  };

  public static Volunteers = {
    ListVolunteers: 50001,
    CreateVolunteer: 50000,
    ViewVolunteerDetails: 50002,
    UpdateVolunteer: 50003,
    ListVolunteerApplications: 50007,
    ViewVolunteerApplication: 50006,
  };

  public static Membership = {
    MembershipModule: 60000,
    Packages: {
      Create: 60001,
      Update: 60002,
      List: 60003,
      ActivateOrDeactivate: 60004,
      ViewDetails: 60005,
    },
    MembershipManagement: {
      ViewDetails: 60006,
      ApproveOrReject: 60007,
      RequestPayment: 60008,
      MarkAsPaid: 60009,
      Cancel: 60010,
      Renew: 60011,
      Upgrade: 60012,
      Downgrade: 60013,
      Reactivate: 60014,
      RequestsList: 60015,
      EditMemberCenter: 60026,
      EditPersonalPhoto: 60040,
      EditMedicalReport: 60041,
      MembershipManagementRequests: 60030,
    },
    Members: {
      Deactivate: 60016,
      Activate: 60017,
      List: 60018,
      ViewDetails: 60019,
      ViewPaymentDetails: 60020,
      SendEmail: 60021,
    },
    TransferRequests: {
      TransferMembers: 60022,
      Review: 60023,
      Approve: 60024,
      Reject: 60025,
      Cancel: 60029,
    },
    Misc: {
      PreviewPayment: 60027,
      DownloadInvoice: 60028,
    },
  };

  public static Competition = {
    CreateCompetition: 70001,
    UpdateCompetition: 70002,
    GetCompetitionList: 70003,
    GetCompetitionDetails: 70004,
    ApproveOrRejectCompetition: 70005,
    ApproveApplication: 70006,
    RejectApplication: 70007,
    GetApplicationList: 70008,
    SubmitEvaluate: 70009,
    ViewParticipantRequestDetails: 70010,
    BulkRegistration: 70011,
    AssignPrize: 70012,
  };

  public static Booking = {
    assets: {
      list: 80007,
    },
    requests: {
      list: 80004,
    },
  };

  public static MediaCenter = {
    view: 90000,
    PhotoList: 90001,
    VideoList: 90002,
    PressReleasesList: 90003,
    PhotoDetails: 90004,
    VideoDetails: 90019,
    PressReleasesDetails: 90006,
    AddCategory: 90021,
    AddPhotos: 90007,
    addVideos: 90008,
    addPressReleases: 90009,
  };
  public static Loyalty = {
    LoyaltySettingsLoyaltyModule: 28000,
    LoyaltySettingsCreate: 28001,
    LoyaltySettingsRead: 28002,
    LoyaltySettingsUpdate: 28003,
    LoyaltySettingsDelete: 28004,

    LoyaltyAttendanceModule: 28005,
    LoyaltyAttendanceRead: 28007,
    LoyaltyAttendanceCreate: 28006,
    LoyaltyAttendanceUpdate: 28008,
    LoyaltyAttendanceDelete: 28009,

    OrganizationCenterModule: 28011,
    OrganizationCenterRead: 28013,
    OrganizationCenterCreate: 28012,
    OrganizationCenterUpdate: 28014,
    OrganizationCenterDelete: 28015,

    NFCMembershipModule: 28020,
    NFCMembershipRead: 28017,

    GiftModule: 28021,
    GiftCreate: 28022,
    GiftRead: 28023,
    GiftUpdate: 28024,
    GiftDelete: 28025,

    OrderModule: 28026,
    OrderRead: 28027,
    OrderUpdate: 28028,
    DashboardModule: 28029,
    DashboardRead: 28030,
  };
  public static Settings = {
    ListSettings: 110001,
    UpdateSettings: 110002,
  };

  public static Survey = {
    CsatTargets: {
      View: 120033,
      Manage: 120034,
    },
  };

  public static WorkFlow = {
    ManageDelegations: 5000,
    ManageProcess: 5001,
  };

  public static PMO = {
    AssignedToMe: 4000,
  };
  public static Committees = {
    PerformanceDashboard: {
      view: 9006,
    },

    Requests: {
      create: 9000,
      // view: 9001
    },

    // CommitteesList: {
    //   view: 9016
    // },

    ModifyRequest: {
      view: 9003,
    },

    Evaluations: {
      create: 9007,
      view: 9008,
      cancel: 9010,
      close: 9009,
      edit: 9023,

      Observation: {
        create: 9012,
        reopen: 9015,
        close: 9014,
      },
    },

    Settings: {
      Voting: {
        create: 9019,
        view: 9018,
        update: 9020,
        delete: 9021,
      },

      WeightSettings: {
        view: 9022,
      },
      sponsershipSettings: {
        view: 9025,
      },
    },
  };

  public static BAU = {
    OperationPlan: {
      view: 7001,
    },
    Roles: {
      view: 7007,
      create: 7008,
      edit: 7009,
      delete: 7010,
    },
  };

  public static EmployeeAppraisal = {
    planning: {
      showSendReminder: 8016,
    },
    Competencies: {
      view: 8011,
      create: 8008,
      update: 8009,
      delete: 8010,
      toggleActivate: 8009,
    },
    StaticKPIs: {
      view: 8007,
      delete: 8006,
      toggleActivate: 8005,
      add: 8004,
      edit: 8005,
    },
    courses: {
      view: 8002,
      create: 8000,
      update: 8001,
      cancel: 8003,
      updateAttendanceStatus: 8012,
      downloadInviteesTemplate: 8015,
      addInvitees: 8015,
      security: 8019,
    },
    HappinessKpis: {
      view: 8017,
      edit: 8018,
      importResulte: 8018,
    },
    KpisSSettings: {
      view: 8020,
    },
  };

  public static Innovation = {
    assessment: {
      view: 10001,
    },
    Rewards: {
      ManageRewards: 10005,
      GetRewardConfiguration: 10006,
    },
  };

  public static CMS = {
    View: 5002,
    selectedIdeas: {
      view: 10004,
    },
    Rewards: {
      ManageRewards: 10005,
      GetRewardConfiguration: 10006,
    },
  };

  public static Partnership = {
    dashboard: {
      view: 20002,
    },

    partners: {
      list: 20001,
      details: 20002,
      verfication: 20003,
    },
    partnership: {
      list: 20017,
      create: 20005,
    },
    requests: {
      list: 20029,
    },
    beneficiaries: {
      view: 20006,
      add: 20007,
    },
    tasks: {
      view: 20008,
      add: 20009,
    },
    communication: {
      view: 20010,
      add: 20011,
    },
    kpis: {
      view: 20012,
      add: 20013,
    },
    risks: {
      add: 20027,
      view: 20028,
    },
    evaluation: {
      view: 20014,
      add: 20019,
      update: 20020,
      getEvaluationCriteria: 20020,
      delete: 20022,
    },
    contract: {
      view: 20036,
      add: 20034,
      update: 20035,
      delete: 20037,
    },
    users: {
      view: 20015,
      add: 20016,
    },
    topic: {
      AddTopic: 20023,
      Update: 20024,
      Get: 20025,
      Delete: 20026,
    },
    about: {
      view: 20031,
    },
  };

  public static Donations = {
    FunboxManagement: {
      view: 10001,
      Create: 120017,
      list: 120018,
    },
    GiftCardCategory: {
      list: 120006,
      Create: 120002,
    },
    GiftCardTemplate: {
      list: 120013,
      Create: 120009,
    },
    Rewards: {
      ManageRewards: 10005,
      GetRewardConfiguration: 10006,
    },
    donationsReport: {
      list: 120026,
    },
  };

  // public static ContentManagement = {
  //   view: 13000,
  //   Entities: {
  //     View: 13001,
  //     Create: 13002,
  //     Update: 13003,
  //     Delete: 13004,
  //   },

  //   Services: {
  //     View: 13101,
  //     Create: 13102,
  //     Update: 13103,
  //     Delete: 13104,
  //   },
  //   Booking: {
  //     View: 13201,
  //     Create: 13202,
  //     Update: 13203,
  //     Delete: 13204,
  //   },
  //   Membership: {
  //     View: 13301,
  //     Create: 13302,
  //     Update: 13303,
  //     Delete: 13304,
  //   },
  // };
  
  // Testing Content Management Permissions
  public static ContentManagement = {
    view: 90000,
    Entities: {
      View: 90000,
      Create: 90000,
      Update: 90000,
      Delete: 90000,
    },

    Services: {
      View: 90000,
      Create: 90000,
      Update: 90000,
      Delete: 90000,
    },
    Booking: {
      View: 90000,
      Create: 90000,
      Update: 90000,
      Delete: 90000,
    },
    Membership: {
      View: 90000,
      Create: 90000,
      Update: 90000,
      Delete: 90000,
    },
  };


}
